import './polyfills';

import App from '@/App.vue';
import router from '@/router';
import Router from 'vue-router';
import { ValidationPlugin, ErrorPlugin, FErrorHandlingApp, TestPlugin, TranslationPlugin } from '@fkui/vue';
import { TranslationService } from '@fkui/logic';
import Vue, { VNode } from 'vue';
import './main.scss';
import 'fk-icons/dist/f';
import { translateValidationMessages, ETranslationProvider } from '@exp/vue';
import { APP_TRANSLATIONS_URL } from '@/app.constants';

Vue.config.productionTip = false;

Vue.use(Router);
Vue.use(ValidationPlugin);
Vue.use(TestPlugin);
Vue.use(ErrorPlugin);

async function loadTranslations(): Promise<void> {
    const translationProvider = new ETranslationProvider();
    const translateFunction = await translationProvider.createTranslateFunction({ language: 'sv' });

    try {
        await translationProvider.loadTranslations(APP_TRANSLATIONS_URL);
    } catch (error) {
        // Ignore error silently.
    } finally {
        TranslationService.changeProvider(translationProvider);
        Vue.use(TranslationPlugin);
    }

    translateValidationMessages(translateFunction);
}

async function createApp(): Promise<void> {
    new Vue({
        router,
        render: (h): VNode => h(FErrorHandlingApp, { props: { defaultComponent: App } }),
    }).$mount('#app');
}

loadTranslations().then(createApp);
